import HeaderWidgets from "./components/HeaderWidgets"

export default HeaderWidgets;